/**
 * Formatage des montants TonMonni.
 *
 * Le FCFA n'a pas de sous-unité : les montants sont des entiers, jamais des
 * décimaux (invariant du kit). La maquette sépare les milliers par une espace
 * fine insécable (U+202F) et colle l'unité par une espace insécable (U+00A0),
 * pour qu'un montant ne soit jamais coupé en fin de ligne.
 */

const THIN_NBSP = ' ';
const NBSP = ' ';

/** `25000` → `25 000 FCFA` (espaces fines insécables). */
export function fcfa(amount: number): string {
  const grouped = Math.round(amount).toLocaleString('fr-FR').replace(/\s/g, THIN_NBSP);
  return `${grouped}${NBSP}FCFA`;
}

/** `25000` → `25 k`, `1250000` → `1,3 M`, `450` → `450`. Pour les axes et les jauges. */
export function shortAmount(amount: number): string {
  if (amount >= 1_000_000) {
    const millions = (amount / 1_000_000).toFixed(amount % 1_000_000 ? 1 : 0).replace('.', ',');
    return `${millions}${THIN_NBSP}M`;
  }
  if (amount >= 1000) return `${Math.round(amount / 1000)}${THIN_NBSP}k`;
  return String(amount);
}
